exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".txt-blue[_v-2ce34852]{color:#00e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-2ce34852&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/offers/comments.vue
// module id = 346
// module chunks = 0